import React from 'react';
import { FaBullhorn, FaStore, FaBuilding, FaCalendarAlt, FaPlus } from 'react-icons/fa';
import './FloatingConnectBtn.css';

const FloatingConnectBtn = ({ onClick, view }) => {
    const getIcon = () => {
        // Handle post- views by extracting base
        const baseView = view?.startsWith('post-') ? view.replace('post-', '') : view;

        switch (baseView) {
            case 'market-square': return <FaStore />;
            case 'real-estate': return <FaBuilding />;
            case 'slotify': return <FaCalendarAlt />;
            case 'connect': return <FaBullhorn />;
            default: return <FaPlus />;
        }
    };

    const getTitle = () => {
        const baseView = view?.startsWith('post-') ? view.replace('post-', '') : view;
        switch (baseView) {
            case 'market-square': return "Post in Discover";
            case 'real-estate': return "Post in Property";
            case 'slotify': return "Manage Appointment";
            case 'connect': return "Create Status Post";
            default: return "Post Now";
        }
    };

    return (
        <div className="floating-connect-btn" onClick={onClick} title={getTitle()}>
            <div className="icon-wrapper">
                {getIcon()}
            </div>
            <span className="pulse-ring"></span>
            <span className="pulse-ring delay"></span>
        </div>
    );
};

export default FloatingConnectBtn;
